export default __webpack_public_path__ + "static/media/ezi-Logo.b6a4df61.png";